import React, {useEffect, useState} from "react";
import Button from "../../../components/button";
import Breadcrumbs from "../../../components/breadcrumbs";
import Input from "../../../components/input";
import {ToastContainer, toast} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import {useDispatch, useSelector} from "react-redux";
import {Link, useHistory, useParams} from "react-router-dom";
import {
    updateTeam,
    clear_teams,
    UPDATE_TEAM,
    getAllTeams,
    createUsersTeams,
    CREATE_USERS_TEAMS,
    deleteUsersTeams,
    DELETE_USERS_TEAMS
} from "../../../redux/teams";
import SelectInput from "../../../components/select";
import Footer from "../../../components/footer";
import {Switch, Space} from "antd";
import LoadingSpinner from "../../../components/loading-spinner";
import Modal from "../../../components/modal";
import Select from "react-select";
import {searchUsersActives} from "../../../redux/users";
import {URLAPI} from "../../../config";

const UpdateTeam = () => {
    let history = useHistory();
    const {id} = useParams();

    const dispatch = useDispatch();
    const {token} = useSelector((state) => state.users_module.login.data) || null;

    const _get_all_teams = useSelector((state) => state.teams_module._get_all_teams);
    const _get_all_user_types = useSelector((state) => state.user_types_module._get_all_user_types);

    const [userTypes, setUserTypes] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [modal, setModal] = useState(false);
    // const [users, setUsers] = useState([]);
    const [optionsUsers, setOptionsUsers] = useState([]);
    const [user_select, setUserSelect] = useState([]);

    useEffect(() => {
        if (_get_all_user_types.data.datos) {
            setUserTypes(_get_all_user_types.data.datos);
        }
    }, [_get_all_user_types]);

    const usersActives = async () => {
        const params = '';
        const response = await searchUsersActives(token, params);
        try {
            if (response && response.data && response.data.datos) {
                let options = response.data.datos.map((item) => {
                    return {
                        value: item.id,
                        label: item.nombres,
                        foto: item.foto,
                    };
                });
                setOptionsUsers(options);
            }
        } catch (e) {
            console.log('Error')
        }
    }

    const handleChangeSelect = (e) => {
        setUserSelect(e);
    };

    const _update_team = useSelector((state) => state.teams_module._update_team);
    const _create_users_teams = useSelector((state) => state.teams_module._create_users_teams);
    const _delete_users_teams = useSelector((state) => state.teams_module._delete_users_teams);

    const [form, setForm] = useState({
        nombre: "",
        id_tipo_usuario: 0,
        tipo_usuario: "",
        activo: true,
        usuarios: [],
    });

    const [data, setData] = useState({
        coordinador: false,
        usuarios: [],
    });

    useEffect(() => {
        if (_get_all_teams.data.datos) {
            let item = _get_all_teams.data.datos.filter((x) => x.id === parseInt(id))
            if (item.length > 0) {
                let usuarios = item[0].usuarios.map((x) => {
                    return {
                        value: x.id,
                        label: x.nombres,
                        foto: x.foto,
                        coordinador: x.coordinador
                    };
                })
                setForm({
                    nombre: item[0].nombre,
                    id_tipo_usuario: item[0].id_tipo_usuario,
                    tipo_usuario: item[0].tipo_usuario,
                    activo: item[0].activo,
                    usuarios: usuarios
                })
            }
        }
    }, [_get_all_teams, id]);

    useEffect(() => {
        if (_update_team.status === 200) {
            dispatch(clear_teams(UPDATE_TEAM));
            history.push("/equipos");
            dispatch(getAllTeams(token));
            setIsLoading(false);
        } else if (_update_team.status !== 0) {
            dispatch(clear_teams(UPDATE_TEAM));
            toast.error(_update_team.message, {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
        }
    }, [_update_team, dispatch, history, token]);

    useEffect(() => {
        if (_delete_users_teams.status === 200) {
            dispatch(clear_teams(DELETE_USERS_TEAMS));
            dispatch(getAllTeams(token));
            setIsLoading(false);
        } else if (_delete_users_teams.status !== 0) {
            dispatch(clear_teams(DELETE_USERS_TEAMS));
            toast.error(_delete_users_teams.message, {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
        }
    }, [_delete_users_teams, dispatch, history, token]);

    useEffect(() => {
        if (_create_users_teams.status === 201) {
            toast.success("Creado correctamente", {position: toast.POSITION.TOP_RIGHT});
            dispatch(clear_teams(CREATE_USERS_TEAMS));
            dispatch(getAllTeams(token));
            setIsLoading(false);
            setModal(false);
        } else if (_create_users_teams.status !== 0) {
            dispatch(clear_teams(CREATE_USERS_TEAMS));
            toast.error(_create_users_teams.message, {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
        }
    }, [_create_users_teams, dispatch, history, token]);

    const handleChange = (e) => {
        if (e.target.name === "id_tipo_usuario") {
            setForm({
                ...form,
                [e.target.name]: parseInt(e.target.value),
            });
        } else {
            setForm({
                ...form,
                [e.target.name]: e.target.value,
            });
        }
    };

    const handleCheckedChange = (checked) => {
        setForm({
            ...form,
            activo: checked,
        });
    };

    const handleCheckedCordinatorChange = (checked) => {
        setData({
            ...data,
            coordinador: checked,
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (form.nombre === "") {
            toast.error("Debe ingresar el nombre", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        if (form.id_tipo_usuario === 0) {
            toast.error("Debe seleccionar el tipo", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        dispatch(updateTeam(token, id, form));
    };

    const handleSubmitUser = (e) => {
        e.preventDefault();
        setIsLoading(true);
        let array = user_select.map((item) => {
            return {
                id_usuario: item.value,
            };
        });
        data.usuarios = array;
        if (data.usuarios.length === 0) {
            toast.error("Debe seleccionar al menos una persona", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }

        dispatch(createUsersTeams(token, id, data));
    };

    function delete_item(id_usuario) {
        setIsLoading(true);
        dispatch(deleteUsersTeams(token, id, id_usuario));
    }

    return (
        <div className="app-content content">
            <div className="content-overlay"/>

            <div className="content-wrapper">
                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 mt-1">
                        <Breadcrumbs
                            title="Equipos"
                            items={[
                                {label: "Detalles", link: "/equipos"},
                            ]}
                        />
                    </div>
                </div>
                <div className="content-body">
                    <div className="row">
                        <div className="col-12">
                            <form className="card" onSubmit={handleSubmit}>
                                <div className="card-header">
                                    <h4 className="card-title">Actualizar Equipo</h4>
                                </div>
                                <div className="card-body">
                                    <div><ToastContainer/></div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <Input
                                                name="nombre"
                                                label="Nombre"
                                                value={form.nombre}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>Tipo</label>
                                                <SelectInput
                                                    label="tipo"
                                                    name="id_tipo_usuario"
                                                    value={form.id_tipo_usuario}
                                                    select={form.tipo_usuario}
                                                    onChange={handleChange}
                                                    options={userTypes ? userTypes.map((item) => ({
                                                        name: item.nombre,
                                                        id: item.id,
                                                    })) : []}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <Space size={14} direction='horizontal'>
                                                    <strong>Activo</strong>
                                                    <Switch
                                                        checked={form.activo}
                                                        checkedChildren="SI"
                                                        unCheckedChildren="NO"
                                                        onChange={handleCheckedChange}
                                                    />
                                                </Space>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12 mb-2">
                                            <p className="text-title">Personas</p>
                                            <p className="text-body">Sección para asignar a las personas que conforman
                                                el equipo</p>
                                            <Button type="button" text="Agregar" theme="calendar" classes="mb-1"
                                                    onChange={() => {
                                                        usersActives();
                                                        setModal(true);
                                                    }}/>
                                        </div>
                                        {form.usuarios.length > 0 && (
                                            form.usuarios.map((item) => (
                                                <div className="col-md-6 col-12 mb-1">
                                                    <div className="d-flex p-1 border-card">
                                                        <div className="d-flex" style={{width: '90%'}}>
                                                            <div className="avatar bg-rgba-primary m-0">
                                                                <img
                                                                    src={item.foto ? URLAPI + item.foto : window.location.origin + "/base/app-assets/images/profile/no_perfil.png"
                                                                    }
                                                                    alt="img"
                                                                    height="70"
                                                                    width="70"
                                                                />
                                                            </div>
                                                            <div className="mt-1 ml-2">
                                                                <span>{item.label}</span><br/>
                                                                <span>Coordinador(a): {item.coordinador ? 'SI' : 'NO'}</span>
                                                            </div>
                                                        </div>
                                                        <div className="text-right mt-2" style={{width: "10%"}}>
                                                            <img
                                                                src={window.location.origin + "/base/app-assets/images/icon/delete.png"}
                                                                alt="img"
                                                                height="20"
                                                                width="20"
                                                                onClick={() => {
                                                                    delete_item(item.value)
                                                                }}
                                                                style={{cursor: "pointer"}}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                        )}
                                    </div>
                                    <div className="card-footer button_responsive">
                                        <Link to="/equipos"
                                              className="btn btn-outline-dark magin_button button_responsible">
                                            Cancelar
                                        </Link>
                                        <Button type="submit" text="Crear" classes="button_responsible" theme="calendar"
                                                disabled={isLoading}/>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <Modal className="modal-main div-modal" show={modal}>
                <form onSubmit={handleSubmitUser}>
                    {isLoading && <LoadingSpinner/>}
                    <div className="card-body">
                        <h5 className="titulo_modal type_text mb-2">Agregar persona</h5>
                        <div className="form-group">
                            <label>Personas</label>
                            <Select
                                value={user_select}
                                options={optionsUsers}
                                isMulti={true}
                                onChange={handleChangeSelect}
                            />
                        </div>
                        <div className="form-group">
                            <Space size={14} direction='horizontal'>
                                <strong>Es Coordinador</strong>
                                <Switch
                                    checked={data.coordinador}
                                    checkedChildren="SI"
                                    unCheckedChildren="NO"
                                    onChange={handleCheckedCordinatorChange}
                                />
                            </Space>
                        </div>

                    </div>
                    <div className="card-footer text-center">
                        <button disabled={isLoading} className={`btn btn-calendar mb-1 button_div`}>Guardar</button>
                        <button type="button" onClick={() => {
                            setModal(false);
                        }} className={`btn btn-outline-calendar button_div`}>Cancelar
                        </button>
                    </div>
                </form>
            </Modal>
            <Footer/>
        </div>
    );
};

export default UpdateTeam;
